// CRIO_SOLUTION_START_MODULE_CHECKOUT
// CRIO_SOLUTION_END_MODULE_CHECKOUT
// import { Button } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
// import { useHistory } from 'react-router-dom'
import Footer from './Footer'
import Header from './Header'
import './Thanks.css'

const TermsOfService = () => {
  // const history = useHistory()

  // const routeToProducts = () => {
  //   history.push('/')
  // }

  // useEffect(() => {
  //   const token = localStorage.getItem('token')

  //   if (!token) {
  //     history.push('/')
  //   }
  // }, [history])

  return (
    <>
      <Header />
      <Box className="greeting-container">
        <h2>Terms of Service</h2>
        <p>Please read these Terms and Conditions before using https://crio.do/ (hereinafter referred to
as the Website) operated by QIFT SOLUTECH PRIVATE LIMITED ( hereinafter referred
to as Company) with its registered office at 176 A, 3RD CROSS, B BLOCK, SRI KRISHNA
GARDEN LAYOUT, BENGALURU, KARNATAKA - 560059
YOUR ACCESS TO AND USE OF THE SERVICE IS CONDITIONED ON YOUR
ACCEPTANCE OF AND COMPLIANCE WITH THESE TERMS. THESE TERMS APPLY
TO ALL VISITORS, USERS AND OTHERS WHO ACCESS OR USE THE SERVICE. BY
ACCESSING OR USING THE SERVICE YOU AGREE TO BE BOUND BY THESE
TERMS. IF YOU DISAGREE WITH ANY PART OF THE TERMS THEN YOU ARE
REQUESTED TO REFRAIN FROM ACCESSING THE SERVICE.

<br/><br/>
DEFINITIONS
1. ‘Contract’ – the document or documents setting out the services to be provided by Us
together with these terms and conditions
2. “We”, “Our”, and “Us” - shall mean and refer to the Company
3. ‘You’, ‘User’ – the person, firm or organisation engaging our services.
4. ‘Software’ - any executable files, help files and all other documentation and content that
is in addition to the service available on the Website for download, installation or
purchase by Users.
<br/><br/>

1. FORMATION OF CONTRACT
A contract would exist between Us and You as soon as You make the initial payment for
booking Our services.
2. SCOPE OF SERVICES
<br/><br/>

We provide an environment optimized for learning and empower developers with “work-
like” Micro- Experiences chosen from industry. The developers are given an insight into the
<br/><br/>

real world problems and the solution landscape. We offer services like Learning Content, a
Work-like infrastructure for learning, Git account and Code stubs, Provisioned Virtual
machines, Test suite and assessment service, Slack workspace and Mentoring over slack or
in-person.
<br/><br/>

3. REGISTRATION
1. Users shall register in order to get access to the services provided by the
Company through the Website.


2. Facebook or Google Plus Accounts may be linked in order to facilitate
registration.


3. Users may explore the Website on a trial for a period of ________ through an
Access Code provided by Us. Please note that You shall access only such limited
content and functions as may be prescribed by Us during the trial period.


4. Only those individuals who have attained majority can register themselves with
Us. Individuals under the age of 18 years shall utilise or browse our Website only
with the involvement, guidance and supervision of their parents and / or legal
guardians, using such parent /legal guardian’s registered account.


4. PAYMENT
<br/><br/>

1. Registration to the Website is free of cost.


2. Customers shall pay the prescribed amount for availing any of the Services
offered by Us. We shall provide access to the content only after receiving the full
payment.

3. Payment shall be made through credit/debit card, digital wallets or internet
banking.

4. We use a third-party payment gateway ____________. The relationship between
the Users and third-party payment gateway shall be governed by the Terms of
Use and Privacy Policy of the said payment gateway and We shall not be party to
any dispute arising there from. We are also not liable for any errors or delays
made by the third-party payment gateway.
<br/><br/>

5. CANCELLATION/REFUND POLICY
1. You cannot change or cancel your subscription plan once You have subscribed
and made the requisite payment. Consequently, no refunds shall be processed on
cancellation of subscription or membership.
2. We shall not provide refunds where Your access is interrupted due to Your
insufficient system requirements such as poor Internet connection, incompatible
hardware/software and the like.

<br/><br/>
6. WARRANTIES AND LIABILITIES
1. We do not warrant, guarantee or endorse the accuracy, completeness or quality of
content and representations offered on our Website.
2. We undertake no liability, in any circumstances whatsoever, for the standard of
services provided by third-party payment gateways.
3. We are not liable for events beyond the company’s control such as natural calamities,
acts of terrorism or other similar factors which cannot be reasonably mitigated
against.

4. We are not responsible for any interruption of service or any loss of data while
transmitting any information over the internet.
5. We do not have any control over the content and resources provided by the third
party websites through ads or links.
<br/><br/>

7. OBLIGATIONS AND FORMAL UNDERTAKINGS AS TO CONDUCT
1. You agree and acknowledge that You are a restricted user of this Website, and that
You shall refrain from providing any information:
a. which is false, fraudulent, inaccurate, misleading or incomplete; or
b. which is defamatory, libellous, unlawfully threatening or unlawfully
harassing; or
c. which contains any viruses, trojan horses, worms, time bombs, cancelbots,
easter eggs or other computer programming routines or executable files that
may damage, detrimentally interfere with, surreptitiously intercept or
expropriate any system, data or personal information of any person
whatsoever; or
d. which creates liability or causes us to lose in whole or in part, the services of
our Internet Service Providers or other service providers/suppliers.

2. You further undertake that You shall not engage in the following activities:
a. Systematic retrieval of data or other content from the Website to create or compile,
directly or indirectly, a collection, compilation, database, or directory without
written permission from us.

b. Any unauthorized use of the Website, including collection of usernames and/or
email addresses of other users by electronic or other means for the purpose of
sending unsolicited email, or creating user accounts by automated means or under
false pretences.
c. Circumvention, disablement, or interference with security-related features of the
Website, including features that prevent or restrict the use or copying of any
content or enforce limitations on the use of the Website.
d. Unauthorized framing of or linking to the Website.
e. Trick, defraud, or mislead Us and other Users, especially in any attempt to learn
sensitive account information such as user passwords.
f. Attempt to impersonate another user or person or use the username of another
user.
g. Sell or otherwise transfer Your profile.
h. Use any information obtained from the Website in order to harass, abuse, or harm
another person.

i. Use the Website as part of any effort to compete with us or for any revenue-
generating endeavour or commercial enterprise.

j. Disparage, tarnish, or otherwise harm, in our opinion, Us and/or the Website.
k. Use the Website in a manner inconsistent with any applicable laws or regulations.
<br/><br/>

8. TERMINATION OF CONTRACT
1. You may discontinue from our services at any point of time, by either opting out of
your membership from the Website or by writing to us at ping@criodo.com.

2. We reserve the right to unilaterally terminate your use of the Website without notice
or any liability for reasons of breach of the terms mentioned herein.
3. We also reserve the right to deny access to particular Users, to all/any of the services
without any prior notice or explanation in order to protect the interests of other
visitors to the Website.
4. You shall continue to be bound by these Terms, and shall have no right to terminate
these Terms till the expiry of the same.
<br/><br/>

9. INDEMNITY
You agree to indemnify, defend and hold Us harmless from and against all losses, liabilities,
claims, damages, demands, costs and expenses (including legal fees and disbursements in
connection therewith and interest chargeable thereon) asserted against or incurred by Us that
arise out of or result from, any breach or non-performance of any representation, warranty,
covenant or agreement or obligation to be performed by You pursuant to these terms of use.
Further, You agree to hold us harmless against any claims made by any third party due to, or
arising out of, or in connection with:
a. Your use of the Platform,
b. Your violation of these Terms and Conditions;
c. Your violation of any rights of another;
d. Your alleged improper conduct pursuant to these Services;
e. Your conduct in connection with the Website;

You agree to fully co-operate in indemnifying us at your expense. You also agree not to reach
a settlement with any party without our consent.

In no event shall We be liable to compensate You or any third party for any special,
incidental, indirect, consequential or punitive damages whatsoever, including those resulting
from loss of use, data or profits, whether or not foreseeable, and whether or not We had been
advised of the possibility of such damages, or based on any theory of liability, including
breach of contract or warranty, negligence or other tortuous action, or any other claim arising
out of or in connection with the Your use of or access to the Website and/or the Services or
materials contained therein.
<br/><br/>

10. INTELLECTUAL PROPERTY RIGHTS
Nothing contained herein shall give the Customer a right to use any of the Website’s trade
names, trademarks, service marks, logos, domain names, information, questions, answers,
solutions, reports and other distinctive features, save according to the provisions of these
Terms. All logos, content, trademarks, brand names, service marks, domain names are the
property of the Company or the respective copyright or trade mark owner. Furthermore, with
respect to the application created by the Company, the Company shall be the exclusive owner
of all the designs, graphics and the like, related to the Website.
The Website contains copyrighted material, trademarks, trade secrets, patents, and other
proprietary information, including, but not limited to, text, software, photos, video, graphics,
music, sound, and the entire contents of the Company protected by copyright as a collective
work under the applicable copyright laws.
You shall not decipher, decompile, disassemble, or reverse engineer any of the software
comprising or in any way making up a part of the Website. No user is authorised to copy or
adapt the Website’s software, including but not limited to Flash, PHP, HTML, JavaScript, or
other code.
We reserve the right to remove any content from our Website that is alleged to infringe any
other person’s intellectual property.
<br/><br/>

11. DISPUTE RESOLUTION TERMS

It is expressly agreed to by the parties hereto that the formation, interpretation and
performance of these Terms and any disputes arising therefrom will be resolved through a
two-step Alternate Dispute Resolution mechanism. It is further agreed to by the parties that
the contents of this Section shall survive even after the termination or expiry of the Terms
and/or the Privacy Policy.
In case of any dispute between the parties, the parties will attempt to resolve the same
amicably amongst themselves, to the mutual satisfaction of all parties. In the event that the
Parties are unable to reach such an amicable solution within thirty (30) days of one party
communicating the existence of a dispute to the other, the dispute shall be resolved by
arbitration.
The parties expressly agree that the Terms, Policy and any other agreements entered into
between the parties are governed by the laws, rules and regulations of India. The policy shall
be governed by and construed in accordance with the laws of India. Each party hereby
irrevocably submits to the exclusive jurisdiction of the courts of_____________, India, for
the adjudication of any dispute hereunder or in connection herewith.
<br/><br/>

12. NOTICES
Any and all communication relating to any dispute or grievance experienced by the User
may be communicated to the Company by the Customer by emailing to _____
<br/><br/>

13. MISCELLANEOUS PROVISIONS

a. Entire Agreement: These Terms, read with the Privacy Policy, form the complete and
final contract between the User and the Company with respect to the subject matter
hereof and supersedes all other communications, representations and agreements
(whether oral, written or otherwise) relating thereto.

b. Waiver: The failure of either You or Us, at any time to require performance of any
provision of these Terms, shall in no manner affect such party's right at a later time to
enforce the same. No waiver by either party of any breach of these Terms, whether by
conduct or otherwise, in any one or more instances, shall be deemed to be or construed as
a further or continuing waiver of any such breach, or a waiver of any other breach of
these Terms.
c. Severability: If any provision of these Terms is held to be illegal, invalid, or
unenforceable by any court or authority of competent jurisdiction, the legality, validity,
and enforceability of the remaining provisions of these Terms shall in no way be affected
or impaired thereby, and each such provision shall be valid and enforceable to the fullest
extent permitted by law. In such case, these Terms shall be reformed to the minimum
extent necessary to correct any illegality, invalidity or unenforceability.
</p>
       
      </Box>
      <Footer />
    </>
  )
}

export default TermsOfService
